// Curated open-source exercise seed data.
// Source: free-exercise-db (https://github.com/yuhonas/free-exercise-db) — MIT License.
// Trimmed and reshaped to fit the mypt exercise schema.
// videoUrl points to a public YouTube demonstration where available.

export const OPEN_EXERCISE_LIBRARY = [
  { name: "Barbell Back Squat", category: "Strength", bodyArea: "Legs", muscle: "Quadriceps",
    description: "Compound lower-body lift performed with a barbell racked across the upper back.",
    teachingPoints: "Brace core; chest up; knees track over toes; descend until thighs parallel; drive through midfoot.",
    adaptations: "Goblet squat with a single dumbbell for beginners; pause squat for advanced control.",
    videoUrl: "https://www.youtube.com/watch?v=ultWZbUMPL8" },

  { name: "Barbell Front Squat", category: "Strength", bodyArea: "Legs", muscle: "Quadriceps",
    description: "Squat variant with the bar racked across the front delts to emphasise the quads and upright torso.",
    teachingPoints: "Elbows high; tight rack position; vertical torso; full depth.",
    adaptations: "Use a cross-arm grip if shoulder mobility is limited.",
    videoUrl: "https://www.youtube.com/watch?v=tlfahNdNPPI" },

  { name: "Conventional Deadlift", category: "Strength", bodyArea: "Back", muscle: "Erector Spinae",
    description: "Hip-hinge pull from the floor using a barbell — full posterior chain.",
    teachingPoints: "Bar over midfoot; neutral spine; lats engaged; push the floor away.",
    adaptations: "Trap-bar deadlift for a more knee-friendly setup.",
    videoUrl: "https://www.youtube.com/watch?v=op9kVnSso6Q" },

  { name: "Romanian Deadlift", category: "Hypertrophy", bodyArea: "Legs", muscle: "Hamstrings",
    description: "Hip-hinge with a slight knee bend that loads the hamstrings and glutes.",
    teachingPoints: "Soft knees; bar drags down the legs; sit hips back; stop when hamstrings tighten.",
    adaptations: "Single-leg RDL for unilateral strength.",
    videoUrl: "https://www.youtube.com/watch?v=2SHsk9AzdjA" },

  { name: "Barbell Bench Press", category: "Strength", bodyArea: "Chest", muscle: "Pectoralis Major",
    description: "Horizontal pressing lift, the classic upper-body strength benchmark.",
    teachingPoints: "Retract scapulae; feet planted; bar to lower chest; press in a slight arc.",
    adaptations: "Dumbbell bench press for greater range of motion.",
    videoUrl: "https://www.youtube.com/watch?v=rT7DgCr-3pg" },

  { name: "Incline Dumbbell Press", category: "Hypertrophy", bodyArea: "Chest", muscle: "Upper Pectorals",
    description: "Dumbbell press performed on an inclined bench to bias the upper chest.",
    teachingPoints: "Bench at 30°; press dumbbells together at the top; control the descent.",
    adaptations: "Neutral-grip variation if shoulders are sensitive.",
    videoUrl: "https://www.youtube.com/watch?v=8iPEnn-ltC8" },

  { name: "Push-Up", category: "Strength", bodyArea: "Chest", muscle: "Pectoralis Major",
    description: "Bodyweight horizontal press; the foundational upper body movement.",
    teachingPoints: "Plank line from head to heel; elbows ~45°; chest grazes the floor.",
    adaptations: "Knee or incline push-up for beginners; deficit push-up for advanced.",
    videoUrl: "https://www.youtube.com/watch?v=IODxDxX7oi4" },

  { name: "Pull-Up", category: "Strength", bodyArea: "Back", muscle: "Latissimus Dorsi",
    description: "Bodyweight vertical pull from a dead hang to chin over the bar.",
    teachingPoints: "Pack shoulders; pull elbows down and back; full hang at the bottom.",
    adaptations: "Band-assisted pull-up; lat pulldown for novices.",
    videoUrl: "https://www.youtube.com/watch?v=eGo4IYlbE5g" },

  { name: "Chin-Up", category: "Strength", bodyArea: "Back", muscle: "Latissimus Dorsi",
    description: "Underhand-grip pull-up that brings the biceps in more strongly.",
    teachingPoints: "Supinated grip shoulder-width; chest to bar; controlled descent.",
    adaptations: "Negative chin-ups to build strength.",
    videoUrl: "https://www.youtube.com/watch?v=brhRXlOhsAM" },

  { name: "Bent-Over Barbell Row", category: "Strength", bodyArea: "Back", muscle: "Latissimus Dorsi",
    description: "Hip-hinged horizontal pull with a barbell — builds mid-back thickness.",
    teachingPoints: "Flat back; pull the bar to the lower ribs; squeeze the shoulder blades.",
    adaptations: "Pendlay row from the floor each rep.",
    videoUrl: "https://www.youtube.com/watch?v=vT2GjY_Umpw" },

  { name: "Seated Cable Row", category: "Hypertrophy", bodyArea: "Back", muscle: "Mid Back",
    description: "Machine row that isolates the mid-back with constant tension.",
    teachingPoints: "Tall chest; pull the handle to the navel; pause and squeeze.",
    adaptations: "Use a wide bar for upper back focus.",
    videoUrl: "https://www.youtube.com/watch?v=GZbfZ033f74" },

  { name: "Overhead Press", category: "Strength", bodyArea: "Shoulder", muscle: "Deltoid",
    description: "Standing barbell shoulder press — full-body stability and pressing strength.",
    teachingPoints: "Glutes tight; bar over the midfoot at lockout; head through the window.",
    adaptations: "Seated dumbbell press for joint-friendly variation.",
    videoUrl: "https://www.youtube.com/watch?v=2yjwXTZQDDI" },

  { name: "Dumbbell Lateral Raise", category: "Hypertrophy", bodyArea: "Shoulder", muscle: "Lateral Deltoid",
    description: "Isolation movement that targets the side delts.",
    teachingPoints: "Slight elbow bend; lead with the elbows; stop at shoulder height.",
    adaptations: "Cable lateral raise for constant tension.",
    videoUrl: "https://www.youtube.com/watch?v=3VcKaXpzqRo" },

  { name: "Face Pull", category: "Hypertrophy", bodyArea: "Shoulder", muscle: "Rear Deltoid",
    description: "Cable rope row to the face — improves rear delt and rotator cuff health.",
    teachingPoints: "Pull rope to forehead; external rotation at the end; elbows high.",
    adaptations: "Band face pull at home.",
    videoUrl: "https://www.youtube.com/watch?v=rep-qVOkqgk" },

  { name: "Barbell Curl", category: "Hypertrophy", bodyArea: "Arms", muscle: "Biceps",
    description: "Classic standing curl with a straight or EZ bar.",
    teachingPoints: "Elbows pinned; full range; no body english.",
    adaptations: "EZ bar curl if wrists complain.",
    videoUrl: "https://www.youtube.com/watch?v=kwG2ipFRgfo" },

  { name: "Hammer Curl", category: "Hypertrophy", bodyArea: "Arms", muscle: "Brachialis",
    description: "Neutral-grip dumbbell curl that hits the brachialis and brachioradialis.",
    teachingPoints: "Palms face each other; control the eccentric.",
    adaptations: "Cross-body hammer curl for variation.",
    videoUrl: "https://www.youtube.com/watch?v=zC3nLlEvin4" },

  { name: "Triceps Rope Pushdown", category: "Hypertrophy", bodyArea: "Arms", muscle: "Triceps",
    description: "Cable triceps isolation using a rope attachment.",
    teachingPoints: "Elbows tucked; spread the rope at the bottom; full extension.",
    adaptations: "Single-arm pushdown for asymmetry work.",
    videoUrl: "https://www.youtube.com/watch?v=vB5OHsJ3EME" },

  { name: "Close-Grip Bench Press", category: "Strength", bodyArea: "Arms", muscle: "Triceps",
    description: "Bench press with a shoulder-width grip to load the triceps.",
    teachingPoints: "Hands ~shoulder width; elbows close; bar to lower chest.",
    adaptations: "Floor press to limit range for shoulders.",
    videoUrl: "https://www.youtube.com/watch?v=nEF0bv2FW94" },

  { name: "Walking Lunge", category: "Strength", bodyArea: "Legs", muscle: "Quadriceps",
    description: "Alternating-leg lunge that travels forward each step.",
    teachingPoints: "Long stride; rear knee taps the floor softly; torso upright.",
    adaptations: "Reverse lunge for less knee stress.",
    videoUrl: "https://www.youtube.com/watch?v=L8fvypPrzzs" },

  { name: "Bulgarian Split Squat", category: "Hypertrophy", bodyArea: "Legs", muscle: "Quadriceps",
    description: "Rear-foot elevated split squat — heavy unilateral leg work.",
    teachingPoints: "Front foot far enough forward; vertical shin or slight forward lean for glute bias.",
    adaptations: "Hold dumbbells for added load.",
    videoUrl: "https://www.youtube.com/watch?v=2C-uNgKwPLE" },

  { name: "Hip Thrust", category: "Hypertrophy", bodyArea: "Legs", muscle: "Glutes",
    description: "Barbell glute bridge with shoulders on a bench — premium glute builder.",
    teachingPoints: "Chin tucked; ribs down; full hip extension; pause at the top.",
    adaptations: "Single-leg hip thrust for unilateral focus.",
    videoUrl: "https://www.youtube.com/watch?v=xDmFkJxPzeM" },

  { name: "Glute Bridge", category: "Warm Up", bodyArea: "Legs", muscle: "Glutes",
    description: "Bodyweight bridge to activate the glutes.",
    teachingPoints: "Drive through heels; squeeze the glutes at the top; avoid arching the lower back.",
    adaptations: "Add a band around the knees for extra activation.",
    videoUrl: "https://www.youtube.com/watch?v=OUgsJ8-Vi0E" },

  { name: "Plank", category: "Strength", bodyArea: "Core", muscle: "Rectus Abdominis",
    description: "Isometric anti-extension core hold on forearms and toes.",
    teachingPoints: "Glutes squeezed; ribs tucked; neutral neck; breathe.",
    adaptations: "Knee plank to regress; long-lever plank to progress.",
    videoUrl: "https://www.youtube.com/watch?v=ASdvN_XEl_c" },

  { name: "Side Plank", category: "Strength", bodyArea: "Core", muscle: "Obliques",
    description: "Lateral core hold on one forearm, hip lifted off the floor.",
    teachingPoints: "Stack the feet; hips high; straight line from head to feet.",
    adaptations: "Drop the bottom knee for a regression.",
    videoUrl: "https://www.youtube.com/watch?v=K2VljzCC16g" },

  { name: "Hanging Leg Raise", category: "Hypertrophy", bodyArea: "Core", muscle: "Rectus Abdominis",
    description: "Bar hang with controlled leg lifts for the lower abs.",
    teachingPoints: "Avoid swing; curl the pelvis up; lower with control.",
    adaptations: "Knee raise variation as a regression.",
    videoUrl: "https://www.youtube.com/watch?v=Pr1ieGZ5atk" },

  { name: "Russian Twist", category: "Hypertrophy", bodyArea: "Core", muscle: "Obliques",
    description: "Seated rotational core movement, often weighted.",
    teachingPoints: "Lift the chest; rotate from the trunk; tap the floor on each side.",
    adaptations: "Feet on the floor for less difficulty.",
    videoUrl: "https://www.youtube.com/watch?v=wkD8rjkodUI" },

  { name: "Treadmill Run", category: "Cardio", bodyArea: "Cardio", muscle: "Cardiovascular",
    description: "Steady-state or interval running on a treadmill.",
    teachingPoints: "Land midfoot; relaxed shoulders; cadence ~170-180 spm.",
    adaptations: "Incline walking for low-impact cardio.",
    videoUrl: "https://www.youtube.com/watch?v=brFHyOtTwH4" },

  { name: "Rowing Machine", category: "Cardio", bodyArea: "Full Body", muscle: "Cardiovascular",
    description: "Indoor rower for full-body conditioning.",
    teachingPoints: "Drive legs first, then back, then arms; reverse on the recovery.",
    adaptations: "Damper 3–5 for most users.",
    videoUrl: "https://www.youtube.com/watch?v=H0r_ZPXJLtg" },

  { name: "Kettlebell Swing", category: "Cardio", bodyArea: "Full Body", muscle: "Glutes",
    description: "Hip-hinge ballistic — explosive glute and hamstring drive.",
    teachingPoints: "Hike the bell back; snap hips; bell floats to chest height.",
    adaptations: "American swing (overhead) for advanced lifters.",
    videoUrl: "https://www.youtube.com/watch?v=YSxHifyI6s8" },

  { name: "Burpee", category: "Cardio", bodyArea: "Full Body", muscle: "Cardiovascular",
    description: "Squat-thrust to push-up to jump — total body conditioning.",
    teachingPoints: "Land softly; chest to floor on the push-up; reach tall on the jump.",
    adaptations: "Step-back burpee without a push-up.",
    videoUrl: "https://www.youtube.com/watch?v=TU8QYVW0gDU" },

  { name: "Mountain Climber", category: "Cardio", bodyArea: "Core", muscle: "Hip Flexors",
    description: "Plank position with alternating knee drives.",
    teachingPoints: "Hips low; quick feet; brace the core.",
    adaptations: "Slow tempo for stability work.",
    videoUrl: "https://www.youtube.com/watch?v=nmwgirgXLYM" },

  { name: "Farmer's Carry", category: "Strength", bodyArea: "Full Body", muscle: "Grip",
    description: "Loaded walking carry — grip, core, and traps.",
    teachingPoints: "Tall posture; ribs down; smooth, even steps.",
    adaptations: "Single-arm suitcase carry.",
    videoUrl: "https://www.youtube.com/watch?v=ZX4ZN3jcJfA" },

  { name: "Cat-Cow Stretch", category: "Warm Up", bodyArea: "Core", muscle: "Spine Mobility",
    description: "Quadruped spine flexion and extension flow for mobility.",
    teachingPoints: "Move with breath; reach the crown forward in cow, round in cat.",
    adaptations: "Seated cat-cow if knees are sensitive.",
    videoUrl: "https://www.youtube.com/watch?v=kqnua4rHVVA" },

  { name: "World's Greatest Stretch", category: "Warm Up", bodyArea: "Full Body", muscle: "Hips and T-Spine",
    description: "Lunge with rotation that opens hips, hamstrings and thoracic spine.",
    teachingPoints: "Front foot flat; hand to the floor; rotate to the ceiling.",
    adaptations: "Hand on a yoga block for limited mobility.",
    videoUrl: "https://www.youtube.com/watch?v=cM0HJa9Xqe0" },

  { name: "Foam Roll Quads", category: "Cool Down", bodyArea: "Legs", muscle: "Quadriceps",
    description: "Self-myofascial release for the front of the thigh.",
    teachingPoints: "Slow passes; pause on tender spots; breathe.",
    adaptations: "Use a softer roller for sensitive tissue.",
    videoUrl: "https://www.youtube.com/watch?v=1vBuwO7Axj0" },
];
